
export enum DeviceOrientation {
    BEHIND = 3,
    FULL_SENSOR = 10,
    FULL_USER = 13,
    LANDSCAPE = 0,
    LOCKED = 14,
    NOSENSOR = 5,
    PORTRAIT = 1,
    REVERSE_LANDSCAPE = 8,
    REVERSE_PORTRAIT = 9,
    SENSOR = 4,
    SENSOR_LANDSCAPE = 6,
    SENSOR_PORTRAIT = 7,
    UNSPECIFIED = -1,
    USER = 2,
    USER_LANDSCAPE = 11,
    USER_PORTRAIT = 12,
}



export function isNativeDevice(){
    return ("nativeDevice" in window);
}

export function isAndroid() {
    const userAgent = navigator.userAgent.toLowerCase();
    return userAgent.indexOf("android") != -1;
}